import { render, staticRenderFns } from "./form-row-specification-table-new.vue?vue&type=template&id=3f98b368&scoped=true&"
import script from "./form-row-specification-table-new.vue?vue&type=script&lang=js&"
export * from "./form-row-specification-table-new.vue?vue&type=script&lang=js&"
import style0 from "./form-row-specification-table-new.vue?vue&type=style&index=0&id=3f98b368&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f98b368",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f98b368')) {
      api.createRecord('3f98b368', component.options)
    } else {
      api.reload('3f98b368', component.options)
    }
    module.hot.accept("./form-row-specification-table-new.vue?vue&type=template&id=3f98b368&scoped=true&", function () {
      api.rerender('3f98b368', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/form-rows/form-row-specification-table-new.vue"
export default component.exports